import { useNavigate } from 'react-router-dom';

const DOT_COLOR = {
  script:          '#8b6dff',
  live_production: '#d4a855',
  ai_production:   '#4daa70',
};

function routeFor(type, id) {
  if (type === 'script')          return `/scripts?script=${id}`;
  if (type === 'live_production') return `/production/${id}`;
  if (type === 'ai_production')   return `/ai?card=${id}`;
  return '/';
}

export default function RecordChip({ id, type, name, detail }) {
  const navigate = useNavigate();

  return (
    <button
      className="record-chip"
      onClick={() => navigate(routeFor(type, id))}
      title={detail}
    >
      <span
        className="record-chip-dot"
        style={{ background: DOT_COLOR[type] || 'var(--tx-muted)' }}
      />
      <span className="record-chip-name">{name}</span>
      {detail && <span className="record-chip-detail">· {detail}</span>}
    </button>
  );
}
